import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import RecipeCard from "./RecipeCard";
import { supabase } from "../supabaseClient";
import "../styles/recipes.css";

export default function Recipes() {
  const [searchParams] = useSearchParams();
  const categorySlug = searchParams.get("category");
  const typeParam = searchParams.get("type"); // slatko ili slano

  const [recipes, setRecipes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      
      // Resetuj recepte prije učitavanja novih
      setRecipes([]);

      try {
        // Učitaj kategorije za mapiranje slug-a na naziv
        const { data: categoriesData } = await supabase
          .from("categories")
          .select("*");
        
        if (categoriesData) {
          setCategories(categoriesData);
        }

        let query = supabase
          .from("recipes")
          .select("*, recipe_images(image_url), taste")
          .order("created_at", { ascending: false });

        // Ako postoji kategorija → filtriraj po category polju
        if (categorySlug) {
          query = query.eq("category", categorySlug);
        }

        const { data, error } = await query;

        if (error) {
          console.error("Greška kod čitanja recepata:", error);
          setRecipes([]);
        } else {
          // Filtriraj po tipu (taste ili type) ako je proslijeđen
          let filteredData = data || [];
          if (typeParam && (typeParam === "slatko" || typeParam === "slano")) {
            // Filtrirati SAMO recepte koji odgovaraju tipu
            filteredData = filteredData.filter((r) => {
              // Provjeri i taste i type polje za kompatibilnost
              const recipeType = r.taste || r.type;
              return recipeType === typeParam;
            });
          }
          
          // Posebna logika: ako je "ostalo" za slano, uključi i recepte iz "pizza" kategorije
          if (categorySlug === "ostalo" && typeParam === "slano") {
            // Učitaj i recepte iz "pizza" kategorije
            const { data: pizzaData } = await supabase
              .from("recipes")
              .select("*, recipe_images(image_url), taste")
              .eq("category", "pizza")
              .order("created_at", { ascending: false });
            
            if (pizzaData) {
              // Filtriraj pizza recepte po tipu
              const pizzaFiltered = pizzaData.filter((r) => {
                const recipeType = r.taste || r.type;
                return recipeType === typeParam;
              });
              // Dodaj pizza recepte u listu
              filteredData = [...filteredData, ...pizzaFiltered];
            }
          }
          
          setRecipes(filteredData);
        }
      } catch (err) {
        console.error(err);
        setRecipes([]);
      }

      setLoading(false);
    }

    load();
  }, [categorySlug, typeParam]);

  if (loading) return <p className="loading">Učitavanje recepata…</p>;

  // Pronađi naziv kategorije po slug-u
  const category = categories.find((c) => c.slug === categorySlug);
  const categoryName = category ? category.name : (categorySlug ? categorySlug.replace(/-/g, " ") : null);

  return (
    <div className="recipes-page">
      <header className="recipes-hero">
        <h1>{categoryName ? `Kategorija: ${categoryName}` : "Svi recepti"}</h1>

        <p>
          {categoryName
            ? `Recepti iz kategorije "${categoryName}".`
            : "Pregled svih bezglutenskih recepata."}
        </p>
      </header>

      <section className="recipes-grid">
        {recipes.length > 0 ? (
          recipes.map((r) => <RecipeCard key={r.id} recipe={r} />)
        ) : (
          <p>Nema recepata u ovoj kategoriji 😊</p>
        )}
      </section>
    </div>
  );
}
